import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import LazyImage from '../LazyImage';
import { SubCategoryImage } from '../../types';

interface TouchImageProps {
    subCategoryNameKey: string;
    image: SubCategoryImage;
}

export const TouchImage = (props: TouchImageProps) => {
    const { subCategoryNameKey, image } = props;

    return <LazyImage alt={translate<string>(subCategoryNameKey)} src={image.touchSrc} srcSet={image.touchSrcSet} />;
};
